import { html, type TemplateResult } from 'lit';

export function renderGoodToKnow(goodToKnowData: {
    title: string;
    content: string | null | undefined;
}): TemplateResult | null {
    if (!goodToKnowData?.content) {
        return null;
    }

    return html`
        <div class="productinfo-good-to-know">
            <der-ui-tile
                icon="systemLightBulb"
                iconColor="#C89608"
                title="${goodToKnowData.title}"
                content="${goodToKnowData.content}"
                variant="info"
            ></der-ui-tile>
        </div>
    `;
}
